import { ComponentProps, ComponentType, FunctionComponent, memo } from 'react';
import classnames from 'classnames/bind';
import { EButtonColor, EButtonSize, TIconPropType } from './_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Button';

type TProps = {
  backgroundColor: EButtonColor;
  size: EButtonSize;
  leftIcon?: ComponentType<TIconPropType> | FunctionComponent<TIconPropType>;
  rightIcon?: ComponentType<TIconPropType> | FunctionComponent<TIconPropType>;
  strokeColor?: Exclude<EButtonColor, EButtonColor.EMPTY> | null;
} & ComponentProps<'button'>;

export const Button = memo(function ButtonComponent({
  children,
  backgroundColor,
  size,
  strokeColor,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  type,
  className,
  ...props
}: TProps) {
  return (
    <button
      className={cn(
        BLOCK_NAME,
        `${BLOCK_NAME}--${backgroundColor}`,
        `${BLOCK_NAME}--${size}`,
        {
          [`${BLOCK_NAME}--disabled`]: props.disabled,
          [`${BLOCK_NAME}--${backgroundColor}-stroke-${strokeColor}`]:
            strokeColor,
          [`${BLOCK_NAME}--${size}-round`]: !children,
        },
        className,
      )}
      color={backgroundColor}
      type={type}
      {...props}
    >
      {LeftIcon && (
        <div className={cn(`${BLOCK_NAME}__icon`, `${BLOCK_NAME}__icon--left`)}>
          <LeftIcon />
        </div>
      )}
      {children}
      {RightIcon && (
        <div
          className={cn(`${BLOCK_NAME}__icon`, `${BLOCK_NAME}__icon--right`)}
        >
          <RightIcon />
        </div>
      )}
    </button>
  );
});
